$(document).ready(function () {
  // ---------------------- add to cart drawer -------------------------
  // AJAX cart redirect to checkout
  $(document).on("click", ".ajax-cart-button.shopify", function () {
    var variantID = $(this).attr("data-product-variant-id");
    $(this).closest(".plus-icon").find(".loading-button").addClass("active");
    $(this).addClass("active");
    addToCartJS(1, variantID, $(this));
  });

  function addToCartJS(qty, variantID, btn) {
    var xhr = new XMLHttpRequest();
    var url = "/cart/add.js";
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        var parsedState = JSON.parse(xhr.responseText);
        $(".loading-button").removeClass("active");
        $(".ajax-cart-button").removeClass("active");
        var event = new CustomEvent("cart:build", {
          detail: "Example of an event",
        });

        // Dispatch/Trigger/Fire the event
        document.dispatchEvent(event);

        var cart = new theme.CartDrawer();
        cart.init();
        cart.open();
      }
    };
    var data = JSON.stringify({ quantity: qty, id: variantID });
    xhr.send(data);
  }


$(document).on("click", ".ajax-cart-button.boost", function () {
  var $btn = $(this);
  var handle = $btn.attr("data-products-handle");

  // Show loading states
  $btn.closest(".plus-icon").find(".loading-button").addClass("active");
  $btn.addClass("active");

  if (!handle) {
    console.error("Product handle is missing.");
    return;
  }

  // Fetch product data using handle
  fetch(`/products/${handle}.js`)
    .then(res => res.json())
    .then(product => {
      var firstVariantId = product.variants[0]?.id;
      if (!firstVariantId) {
        console.error("No variant found for product:", handle);
        return;
      }

      addToCartJSBoost(1, firstVariantId, $btn);
    })
    .catch(err => {
      console.error("Failed to fetch product data:", err);
    });
});
  });